import React from 'react';

import { SvgProps } from 'components/UI/Svg/Svg';
import { Color } from 'modules/styles/colors';
import { SNavStyles } from './index';
import { getFillColor, getStrokeColor } from './utils';

export default (props: SvgProps | undefined) => {
  const getFill = getFillColor(
    props?.active,
    props?.activeFillColor,
    props?.disabled,
    props?.disabledColor,
    props?.color
  );
  const getStroke = getStrokeColor(
    props?.active,
    props?.activeStrokeColor,
    props?.disabled,
    props?.disabledColor,
    props?.color
  );

  return {
    svg: (
      <g {...SNavStyles} strokeWidth="2px" fill={getFill}>
        <circle stroke={getStroke} cx="17.93" cy="18.08" r="12.98" />
        <line
          stroke={getStrokeColor(
            props?.active,
            Color.white,
            props?.disabled,
            props?.disabledColor,
            props?.color
          )}
          x1="18.02"
          y1="11.57"
          x2="18.02"
          y2="24.43"
        />
        <line
          stroke={getStrokeColor(
            props?.active,
            Color.white,
            props?.disabled,
            props?.disabledColor,
            props?.color
          )}
          x1="24.37"
          y1="17.9"
          x2="11.5"
          y2="17.9"
        />
      </g>
    ),
    viewBox: '0 0 36 36'
  };
};
